import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = ({
  title = 'NAQD Consulting - Chartered Accountants in Malappuram, Kerala',
  description = 'Leading chartered accountancy firm in Malappuram, Kerala. Expert tax planning, GST compliance, business registration, and financial consulting services.',
  keywords = 'chartered accountant malappuram, CA kerala, tax consultant malappuram, GST filing kerala, business registration services, NRI taxation india',
  image = '/assets/images/og-image.jpg',
  url = 'https://naqdconsulting.com',
  type = 'website',
  schema = null
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "NAQD Consulting Private Limited",
    "description": description,
    "url": url,
    "telephone": "+919074286763",
    "email": "info@naqd.in",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2nd floor, Span building, Opp. Kendra Vidyalaya, AK Road",
      "addressLocality": "Malappuram",
      "addressRegion": "Kerala",
      "postalCode": "676505",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 11.0414,
      "longitude": 76.0809
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:30",
        "closes": "18:00"
      }
    ],
    "serviceType": [
      "Tax Planning",
      "GST Compliance",
      "Audit & Assurance",
      "Business Registration",
      "Financial Consulting",
      "NRI Tax Services"
    ],
    "areaServed": [
      {
        "@type": "State",
        "name": "Kerala"
      }
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="NAQD Consulting Private Limited" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="NAQD Consulting" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@naqdconsulting" />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Favicon */}
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />

      {/* Structured Data */}
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schema || structuredData)}
      </script>

      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'GA_MEASUREMENT_ID');
        `}
      </script>

      {/* Google Search Console */}
      <meta name="google-site-verification" content="YOUR_VERIFICATION_CODE" />
    </Helmet>
  );
};

export default MetaTags;